var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChipDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4599_189935)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 1.00423,
    rx: 0.502116,
    transform: "matrix(-0.710075 0.704127 -0.710074 -0.704127 11.3936 5.70703)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 1.00423,
    rx: 0.502116,
    transform: "matrix(0.710074 0.704127 -0.710074 0.704127 5.71338 5)",
    fill: "#4f4f4f"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4599_189935"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "#4f4f4f",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChipDelete);
export default __webpack_public_path__ + "static/media/chipDelete.6fc399e9.svg";
export { ForwardRef as ReactComponent };